module.exports = __webpack_public_path__ + "Banner_Tranquil_repeatable-f1275b9e440064fef5fc0bbe45efe965.svg";